import { IUser } from "@/interfaces";

export const getLabel = ({
  fullName,
  givenName,
  surname,
  userPrincipleName,
  displayName,
}: IUser): string => {
  if (displayName) return displayName;

  if (givenName && surname) return `${surname}, ${givenName}`;

  if (userPrincipleName && fullName)
    return `${fullName} (${userPrincipleName})`;

  if (givenName && userPrincipleName)
    return `${givenName} (${userPrincipleName})`;

  return "Error retrieving user info";
};
